/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosCard, CosmosText, EdsIcon } from "@components/elements";
import { css, cx } from "@panda/css";
import { HStack } from "@panda/jsx";
import { CruxLinkFragment } from "@cosmos/hygraph-schema";

const styles = css({
	"&&": {
		justifyContent: "center",
		width: "100%",
		smDown: {
			paddingBlock: "eds.dimension.16",
			borderRadius: "eds.borderRadius.16",
		},
	},
});

const iconWrapperStyles = css({
	"&&": {
		display: "flex",
		width: "eds.dimension.32",
		height: "eds.dimension.32",
		padding: "eds.dimension.6",
		flexShrink: "0",
		justifyContent: "center",
		alignItems: "center",
		borderRadius: "eds.borderRadius.full",
		backgroundColor: "eds.fill.secondary.default",
		"& svg": {
			w: "eds.dimension.20!",
			h: "eds.dimension.20!",
		},
	},
});

export function CruxLink({ label, href, icon, iconGradient }: CruxLinkFragment): React.JSX.Element {
	return (
		<CosmosCard className={cx("crux-link", styles)} variant="material">
			<CosmosCard.Link
				href={href || ""}
				className={css({
					width: "100%",
					display: "flex",
					flexDirection: "column",
					textAlign: "start",
				})}
			>
				<HStack justifyContent="space-between" alignItems="center" gap="eds.dimension.24">
					{icon ? (
						<EdsIcon
							className={css({
								w: "eds.dimension.40!",
								h: "eds.dimension.40!",
								smDown: { w: "eds.dimension.32!", h: "eds.dimension.32!" },
							})}
							icon={icon}
							size="xl"
							gradient={iconGradient}
						/>
					) : null}
					{label ? (
						<CosmosText
							variant="headingMD"
							as="h3"
							color="eds.palette.static.white"
							className={css({
								"&&": {
									w: "100%",
									smDown: {
										textStyle: "headingSM",
										overflow: "hidden",
										whiteSpace: "nowrap",
										textOverflow: "ellipsis",
									},
								},
							})}
						>
							{label}
						</CosmosText>
					) : null}
					<div className={iconWrapperStyles}>
						<EdsIcon icon="ChevronRight" color="primary" size="md" />
					</div>
				</HStack>
			</CosmosCard.Link>
		</CosmosCard>
	);
}
